export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              About Toolbox Property Pros
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Built on Trust,<br />
              Powered by<br />
              Excellence
            </h2>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              At Toolbox Property Pros, we're more than just a property maintenance company. We're your trusted partner in keeping your property pristine, safe, and beautiful throughout every season.
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our team of experienced professionals brings dedication, expertise, and attention to detail to every job. From routine maintenance to specialized services, we treat your property as if it were our own.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="bg-orange-50 rounded-xl p-6 border-2 border-orange-200">
                <div className="text-4xl font-bold text-orange-600 mb-2">100+</div>
                <div className="text-gray-700 font-medium">Happy Clients</div>
              </div>
              <div className="bg-orange-50 rounded-xl p-6 border-2 border-orange-200">
                <div className="text-4xl font-bold text-orange-600 mb-2">1,000+</div>
                <div className="text-gray-700 font-medium">Jobs Completed</div>
              </div>
            </div>

            <button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all hover:shadow-xl whitespace-nowrap cursor-pointer">
              Contact Us
            </button>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/7d92f19e0eae839518251948a5dc238a.jpg"
                alt="Toolbox Property Pros Team"
                className="w-full h-full object-cover object-center"
              />
            </div>
            
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-6 shadow-xl">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-fill text-white text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Licensed &amp; Insured</div>
                  <div className="text-sm text-gray-600">Fully Certified</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}